import { Button } from 'blaze-ui/Button'
import { ReplaceImageButtonProps } from './Types'
import { ArrowRefresh2 } from 'blaze-ui/icons'
import { openImageReplacePrompt } from '../../openImageReplacePrompt'
import { Unsplash } from 'proseShared/IntegrationsIcons'
import { useModals } from 'almanac-ui/Modal'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { ImageMenuModal } from 'components/ImageMenu/ImageMenuModal/ImageMenuModal'
import { ImageMenuSelectedImage } from 'components/ImageMenu/ImageMenuModal/ImageMenuContext'
import { processSelectedImages } from 'components/ImageMenu/utils'
import { replaceImageWithImages } from '../../utils'
import { ACCEPTED_IMAGE_MIME_TYPES_NO_SVG } from 'screens/Finder/components/views/GalleryView/constants'

const ReplaceImageButton = ({ view, attrs }: ReplaceImageButtonProps) => {
  const stackManager = useModals()
  const isNewImageMenuEnabled = useFlipperFlag('new_image_menu')

  const handlePress = async () => {
    if (isNewImageMenuEnabled) {
      let resolveRef: Function

      const closePromise = new Promise<ImageMenuSelectedImage[]>((resolve) => {
        resolveRef = resolve
      })

      stackManager.openModal(ImageMenuModal, {
        accept: ACCEPTED_IMAGE_MIME_TYPES_NO_SVG,
        hiddenProviders: ['stockVideo'],
        maxCount: 1,
        onUse: async (images: ImageMenuSelectedImage[]) => {
          const processedImages = await processSelectedImages(images, { showProcessingToast: true })
          await resolveRef(processedImages)
        },
      })

      const images = await closePromise

      replaceImageWithImages(view, attrs, images)

      stackManager.closeModal()

      return
    }

    openImageReplacePrompt(view, attrs, {
      initialQuery: attrs.unsplashQuery || '',
      preselectedIntegration: Unsplash,
      stackManager,
    })
  }

  return (
    <Button size="lg" frontIcon={ArrowRefresh2} onPress={handlePress}>
      Replace Image
    </Button>
  )
}

export { ReplaceImageButton }
